export default __webpack_public_path__ + "static/media/enova-laptop.07ab18fd.png";